import { archiveProcess, deleteProcess, unarchiveProcess } from "services/processes-service";

export const callDeleteAction = async (itemToDelete, onClose, refetch, setRefetch, SwalReact, t) => {
  const result = await deleteProcess(itemToDelete?._id);
  if (result.status === 200 || result.status === 204) {
    onClose();
    setRefetch(!refetch);
    SwalReact.fire({
      title: t ? t('processes.toasts.successTitle') : 'Sucesso!',
      text: t ? t('processes.toasts.deleted') : 'Processo removido com sucesso',
      icon: 'success',
    });
  } else {
    throw new Error(t ? t('processes.toasts.errorDelete') : 'Ocorreu um erro ao tentar remover o Processo!');
  }
};

export const callArchiveAction = async (itemToArchive, onClose, refetch, setRefetch, SwalReact, t) => {
  const result = await archiveProcess(itemToArchive?._id);
  if (result.status === 200) {
    onClose();
    setRefetch(!refetch);
    SwalReact.fire({
      title: t ? t('processes.toasts.successTitle') : 'Sucesso!',
      text: t ? t('processes.toasts.archived') : 'Processo arquivado com sucesso',
      icon: 'success',
    });
  } else {
    throw new Error(t ? t('processes.toasts.errorArchive') : 'Ocorreu um erro ao tentar arquivar o Processo!');
  }
};

export const callUnarchiveAction = async (itemToUnarchive, onClose, refetch, setRefetch, SwalReact, t) => {
  const result = await unarchiveProcess(itemToUnarchive?._id);
  if (result.status === 200) {
    onClose();
    setRefetch(!refetch);
    SwalReact.fire({
      title: t ? t('processes.toasts.successTitle') : 'Sucesso!',
      text: t ? t('processes.toasts.unarchived') : 'Processo desarquivado com sucesso',
      icon: 'success',
    });
  } else {
    throw new Error(t ? t('processes.toasts.errorUnarchive') : 'Ocorreu um erro ao tentar desarquivar o Processo!');
  }
};
